import { render, staticRenderFns } from "./SimpleSlider.vue?vue&type=template&id=020aad04&"
import script from "./SimpleSlider.vue?vue&type=script&lang=ts&"
export * from "./SimpleSlider.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandXTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VExpandXTransition,VIcon,VProgressCircular})
